// types
import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
  showDetailModal: false,
  showCreateCategoryModal: false,
  showCreateMenuModal: false,
  showCreateCatalogueModal: false,
  showCreateTagModal: false,
  showCreateBizTypeModal: false,
  showCreateBizActivityModal: false,
  selectedTransactionId: null
};

// ==============================|| SLICE - MENU ||============================== //

const utils = createSlice({
  name: 'utils',
  initialState,
  reducers: {
    setShowDetailModal(state, action) {
      state.showDetailModal = action.payload;
    },
    setShowCreateCatalogueModal(state, action) {
      state.showCreateCatalogueModal = action.payload;
    },
    setShowCreateMenuModal(state, action) {
      state.showCreateMenuModal = action.payload;
    },
    setShowCreateCategoryModal(state, action) {
      state.showCreateCategoryModal = action.payload;
    },
    setShowCreateTagModal(state, action) {
      state.showCreateTagModal = action.payload;
    },
    setShowCreateBizTypeModal(state, action) {
      state.showCreateBizTypeModal = action.payload;
    },
    setShowCreateBizActivityModal(state, action) {
      state.showCreateBizActivityModal = action.payload;
    },
    setSelectedTransactionId(state, action) {
      state.selectedTransactionId = action.payload;
    }
  }
});

export default utils.reducer;

export const showDetailModal = (state) => state.utils.showDetailModal;

export const {
  setShowDetailModal,
  setSelectedTransactionId,
  setShowCreateCategoryModal,
  setShowCreateCatalogueModal,
  setShowCreateMenuModal,
  setShowCreateTagModal,
  setShowCreateBizTypeModal,
  setShowCreateBizActivityModal
} = utils.actions;
